import React from 'react';
import insightLeft from '../../img/png/insights_background_left.png';
import insightRight from '../../img/png/insights_background_right.png';
import coreMobileImg from '../../img/png/core_insight.png';
import coreMobileStem from '../../img/png/core_stem.png';
import InsightIcons from './../subcomponents/InsightIcons';
import { AiOutlineMessage } from 'react-icons/ai';
import { FiTarget, FiUsers, FiShoppingCart } from 'react-icons/fi';
import { RiHealthBookLine } from 'react-icons/ri';
import { BsImages, BsClipboardData } from 'react-icons/bs';

function InsightsMobile() {
  return (
    <>
      <section className='insight_mobile d-flex-col justify-content-center align-items-center'>
        <div className='insight_mobile_title d-flex-col align-items-center text-center'>
          <div className='line_container'>
            <h2>Insights</h2>
            <div className='line'></div>
          </div>
          <h3>Measuring your audience behavioral profile</h3>
          <p>
            Through a highly powerful data collection and engineering
            infrastructure and signal detection techniques, SQREEM provides
            enterprises with high precision Digital Insights to measure HCP,
            patients or consumers behaviours and deconstruct their entire online
            journey.
          </p>
        </div>
        <div className='insight_mobile_container d-flex-row justify-content-between gap-1'>
          <div className='insight_mobile_container_center d-flex-col align-items-center justify-content-center gap-1'>
            <div className='core_container'>
              <img src={coreMobileImg} alt='background' />
              {/* <ParticlesCore /> */}
            </div>
            <h3 className='text-center'>Core AI Inights</h3>
          </div>
          <div className='insight_mobile_container_right d-flex-row align-items-center gap-1'>
            <img src={coreMobileStem} alt='background' />
            <div className='icons d-flex-col'>
              <InsightIcons icon={<AiOutlineMessage />} text='Messaging' />
              <InsightIcons icon={<FiTarget />} text='Targeting' />
              <InsightIcons
                icon={<FiUsers />}
                text='Consumer'
                text2='Activation & Supply'
              />
              <InsightIcons
                icon={<RiHealthBookLine />}
                text='HCP'
                text2='Activation & Specialist Supply'
              />
              <InsightIcons
                icon={<FiShoppingCart />}
                text='E-Commerce'
                text2='Activation & Custom Supply'
              />
              <InsightIcons icon={<BsImages />} text='Dynamic Media Format' />
              <InsightIcons
                icon={<BsClipboardData />}
                text='CRM Data Enrichment'
              />
            </div>
          </div>
        </div>
        <div className='insight_mobile_footer text-center d-flex-col justify-content-center'>
          <p>Insights-driven step by step execution</p>
        </div>
        <div className='insight_mobile_background d-flex justify-content-between'>
          <div className='insight_background_left'>
            <img src={insightLeft} alt='background' />
          </div>
          <div className='insight_background_right d-flex-col justify-content-end'>
            <img src={insightRight} alt='background' />
          </div>
        </div>
      </section>
    </>
  );
}

export default InsightsMobile;
